export const DOMAIN = 'askAnalyst.conversationList';
